<template>
  <div>
    <v-app id="app">
      <router-view />
    </v-app>
  </div>
</template>
<script>
export default {
  name: "App"
};
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Yellowtail&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&display=swap');
#app {
  font-family: "Open Sans";
  background: #f2f2f2;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
}
* {
  padding: 0;
  margin: 0;
}
</style>
